module.exports = __webpack_public_path__ + "static/img/sarahfarmer_circle150.c9da7a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/sarahfarmer_circle150.png
// module id = cCL2
// module chunks = 0